
function getProductFetchUrl({sectionUrl, sectionId, params}) {
  return {
    urls: {
      quickshop: `${window.location.origin}${sectionUrl}?view=quick${params}`,
      section: `${window.location.origin}${sectionUrl}?section_id=${sectionId}${params}`
    }
  };
}

async function refreshVariantSelectors({
  context,
  sectionId,
  Product,
  events,
  callback,
  wrapperSelector,
  selectedValueSelector,
  getSelectedValues,
  getCombinedListingUrl,
  config
}) {

  const swatchWrapper = context.querySelector(wrapperSelector);
  if (!swatchWrapper) return;

  let sectionUrl = swatchWrapper.dataset.url || window.location.pathname;
  let isCombinedListing = false;

  if (getCombinedListingUrl) {
    const combinedUrl = getCombinedListingUrl(swatchWrapper);
    if (combinedUrl && combinedUrl !== sectionUrl) {
      sectionUrl = combinedUrl;
      isCombinedListing = true;
    }
  }

  const selectedOptionValues = getSelectedValues(context, swatchWrapper);

  const params = selectedOptionValues.length > 0
    ? `&option_values=${selectedOptionValues.join(',')}`
    : '';

  swatchWrapper.classList.add('is-loading');

  const hashKey = `${sectionUrl}-${selectedOptionValues.join(',')}-${sectionId}`;

  function getVariant(html) {
    if (!html) return false;
    const variant = html.querySelector('[data-selected-variant]')?.innerHTML;
    return !variant ? undefined : JSON.parse(variant);
  }

  function resolveVariantLocally() {
    if (!Product || !Product.variants || !callback) return;
    const checkedInputs = Array.from(swatchWrapper.querySelectorAll('input[type="radio"]:checked'))
      .sort((a, b) => parseInt(a.dataset.position) - parseInt(b.dataset.position));
    const optionValues = checkedInputs.map(i => i.value);
    if (!optionValues.length) return;
    const variant = Product.variants.find(v =>
      !v.options.map((opt, idx) => opt === optionValues[idx]).includes(false)
    ) || null;
    callback(context, variant, config);
  }

  async function fetchData(url, hashKey) {
    if (!cachedVariantHtml.has(hashKey)) {
      const response = await fetch(url) ;
      const responseText = await response.text();
      return responseText;
    } else {
      return cachedVariantHtml.get(hashKey);
    }
  }

  const { quickview: isQuickview } = config;

  if (isQuickview) {

    const responseText = await fetchData(getProductFetchUrl({sectionUrl, params}).urls.quickshop, hashKey);
    const html = new DOMParser().parseFromString(responseText, 'text/html');

    const template = html.querySelector('template#quickshop');

    if (!template) { swatchWrapper.classList.remove('is-loading'); resolveVariantLocally(); return; }

    const content = template.content.cloneNode(true);

    if (!content) { swatchWrapper.classList.remove('is-loading'); return; }

    const newWrapper = content.querySelector(`${wrapperSelector}`);

    if (!newWrapper) { swatchWrapper.classList.remove('is-loading'); resolveVariantLocally(); return; }

    swatchWrapper.innerHTML = newWrapper.innerHTML;
    swatchWrapper.classList.remove('is-loading');

    if (isCombinedListing) {
      const newGallery = content.querySelector('.js-product-gallery');
      const currentGallery = context.querySelector('.js-product-gallery');
      if (newGallery && currentGallery) {
        const mainSlider = context.querySelector('.js-carousel-main');
        const thumbSlider = context.querySelector('.js-thumb-carousel-nav');
        if (mainSlider && typeof Flickity !== 'undefined') {
          const flktyMain = Flickity.data(mainSlider);
          if (flktyMain) flktyMain.destroy();
        }
        if (thumbSlider && typeof Flickity !== 'undefined') {
          const flktyThumb = Flickity.data(thumbSlider);
          if (flktyThumb) flktyThumb.destroy();
        }
        currentGallery.replaceWith(newGallery);
        if (typeof ProductGallery !== 'undefined') {
          ProductGallery.init(context, sectionId);
        }
      }
      swatchWrapper.dataset.url = sectionUrl;
    }

    const newVariant = getVariant(content);

    ProductForm(context, sectionId, events, Product);

    const config = JSON.parse(context.querySelector(`#product-form-${sectionId}`).dataset.productForm || "{}");

    if (callback && typeof callback === "function") {
      callback(context, newVariant, config);
    }

  } else {

    const responseText = await fetchData(getProductFetchUrl({sectionUrl, sectionId, params}).urls.section, hashKey);
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const newWrapper = html.querySelector(`${wrapperSelector}`);

    if (!newWrapper) { swatchWrapper.classList.remove('is-loading'); resolveVariantLocally(); return; }

    swatchWrapper.innerHTML = newWrapper.innerHTML;
    swatchWrapper.classList.remove('is-loading');

    if (isCombinedListing) {
      const newGallery = html.querySelector('.js-product-gallery');
      const currentGallery = context.querySelector('.js-product-gallery');
      if (newGallery && currentGallery) {
        const mainSlider = context.querySelector('.js-carousel-main');
        const thumbSlider = context.querySelector('.js-thumb-carousel-nav');
        if (mainSlider && typeof Flickity !== 'undefined') {
          const flktyMain = Flickity.data(mainSlider);
          if (flktyMain) flktyMain.destroy();
        }
        if (thumbSlider && typeof Flickity !== 'undefined') {
          const flktyThumb = Flickity.data(thumbSlider);
          if (flktyThumb) flktyThumb.destroy();
        }
        currentGallery.replaceWith(newGallery);
        if (typeof ProductGallery !== 'undefined') {
          ProductGallery.init(context, sectionId);
        }
      }
      swatchWrapper.dataset.url = sectionUrl;
    }

    const newVariant = getVariant(html);

    ProductForm(context, sectionId, events, Product);

    const config = JSON.parse(context.querySelector(`#product-form-${sectionId}`).dataset.productForm || "{}");

    if (callback && typeof callback === "function") {
      callback(context, newVariant, config);
    }
  }
}

// Swatches
RefreshSwatches = function(context, sectionId, Product, events, config, callback) {
  refreshVariantSelectors({
    context,
    sectionId,
    Product,
    events,
    callback,
    wrapperSelector: '.product__variants-swatches',
    selectedValueSelector: 'input[type="radio"]:checked',
    getSelectedValues: (ctx, wrapper) =>
      Array.from(wrapper.querySelectorAll('input[type="radio"]:checked')).map(({ dataset }) => dataset.optionValueId),
    getCombinedListingUrl: (wrapper) => {
      const currentUrl = wrapper.dataset.url || window.location.pathname;
      for (const input of wrapper.querySelectorAll('input[type="radio"]:checked[data-product-url]')) {
        if (input.dataset.productUrl !== currentUrl) return input.dataset.productUrl;
      }
      return null;
    },
    config
  });
};

// Dropdowns
RefreshDropdowns = function(context, sectionId, Product, events, config, callback) {
  refreshVariantSelectors({
    context,
    sectionId,
    Product,
    events,
    callback,
    wrapperSelector: '.product__variants-select',
    selectedValueSelector: 'select.js-variant-selector',
    getSelectedValues: (ctx, wrapper) =>
      Array.from(wrapper.querySelectorAll('select.js-variant-selector')).map(select => select.selectedOptions[0]?.dataset.optionValueId),
    getCombinedListingUrl: (wrapper) => {
      const currentUrl = wrapper.dataset.url || window.location.pathname;
      for (const select of wrapper.querySelectorAll('select.js-variant-selector')) {
        const opt = select.selectedOptions[0];
        if (opt && opt.dataset.productUrl && opt.dataset.productUrl !== currentUrl) return opt.dataset.productUrl;
      }
      return null;
    },
    config
  });
};

const cachedVariantHtml = new Map();

const prefetchVariants = function(context, {elements}, sectionId, config) {

  const selectors = {
    "swatches": ".product__variants-swatches",
    "dropdowns": ".product__variants-select"
  };

  const hasSwatches = context.querySelector(selectors.swatches) ? true : false;

  function getOptionValuesFromSwatches(input) {
    const optionValues = [input, ...Array.from(elements).filter(item => item.matches(`input[type="radio"]:not([name="${input.name}"]):checked`))].sort((a,b) => parseInt(a.getAttribute('data-position')) - parseInt(b.getAttribute('data-position'))).map((input2) => input2.getAttribute('data-option-value-id'));
    return optionValues
  };

  function getOptionValuesFromDropdowns(input, allOptions) {
    const optionValues = [input, ...Array.from(allOptions).filter(option => option.matches(`option[data-option-value-id]:not([name="${input.getAttribute('name')}"]):checked`))].sort((a,b) => parseInt(a.getAttribute('data-position')) - parseInt(b.getAttribute('data-position'))).map(input => input.getAttribute('data-option-value-id'));
    return optionValues;
  };

  async function cacheHtmlPromise(optionValues, overrideUrl) {

    const { url: defaultUrl } = hasSwatches ? context.querySelector(selectors.swatches).dataset : context.querySelector(selectors.dropdowns).dataset;
    const sectionUrl = overrideUrl || defaultUrl;

    const params = optionValues.length > 0
    ? `&option_values=${optionValues.join(',')}`
    : '';

    const hashKey = `${sectionUrl}-${optionValues.join(',')}-${sectionId}`;

    if (!cachedVariantHtml.has(hashKey)) {
      const { quickview: isQuickview } = config;
      const response = isQuickview ? await fetch(getProductFetchUrl({sectionUrl, params}).urls.quickshop) : await fetch(getProductFetchUrl({sectionUrl, sectionId, params}).urls.section);
      const responseText = await response.text();
      cachedVariantHtml.set(hashKey, responseText);
    }
  };

  function handleSwatches(elements) {
    const wrapper = context.querySelector(selectors.swatches);
    const currentUrl = wrapper ? wrapper.dataset.url : window.location.pathname;
    Array.from(elements).filter(item => item.matches('input[type="radio"]:not(:checked)')).forEach(item => {
      const optionValues = getOptionValuesFromSwatches(item);
      const productUrl = item.dataset.productUrl;
      const overrideUrl = (productUrl && productUrl !== currentUrl) ? productUrl : undefined;
      cacheHtmlPromise(optionValues, overrideUrl);
    });
  };

  function handleDropdowns(context) {
    const allOptions = context.querySelectorAll('option[data-option-value-id]');
    Array.from(context.querySelectorAll('option[data-option-value-id]:not(:checked)')).forEach(item => {
      const optionValues = getOptionValuesFromDropdowns(item, allOptions);
      cacheHtmlPromise(optionValues);
    });
  };

  if (hasSwatches) {
    handleSwatches(elements);
  } else {
    // We cannot pass elements to this function because the <option> element is not included.
    // See https://developer.mozilla.org/en-US/docs/Web/API/HTMLFormElement/elements#value
    handleDropdowns(context);
  }
};

ProductForm = function (context, sectionId, events, Product) {
  var prodForm = context.querySelector(`#product-form-${sectionId}`);
  var config = JSON.parse(prodForm.dataset.productForm || '{}');
  var selector, varSelectors, options, variant;

  if (context.querySelector('#formVariantId')) {
    context.querySelector('#formVariantId').setAttribute('name', 'id');
  }

  // variant only js below
  if ( Product.has_only_default_variant ) return false;

  (function lazyLoadPrefetch() {
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(context);
        prefetchVariants(context, prodForm, sectionId, config);
      },
      {
        rootMargin: '0px 0px 200px 0px',
      });
      observer.observe(context);
    } else {
      prefetchVariants(context, prodForm, sectionId, config);
    }
  })();

  varSelectors = context.querySelectorAll('.js-variant-selector');

  varSelectors.forEach((item, i) => {
    item.addEventListener("change", function (event) {
      event.preventDefault();

      // Optional: skip if config.swatches is not active
      if (config.swatches === 'swatches') {
        // Resolve variant immediately from local data so UI updates without waiting for the fetch
        const _sw = context.querySelector('.product__variants-swatches');
        if (_sw && Product && Product.variants) {
          const _checked = Array.from(_sw.querySelectorAll('input[type="radio"]:checked'))
            .sort((a, b) => parseInt(a.dataset.position) - parseInt(b.dataset.position));
          const _vals = _checked.map(i => i.value);
          if (_vals.length) {
            const _v = Product.variants.find(v => !v.options.map((o, i) => o === _vals[i]).includes(false)) || null;
            variantEvents(context, _v, config);
          }
        }
        // Still fetch in the background to update swatch availability states
        RefreshSwatches(context, sectionId, Product, events, config, variantEvents);
        return;
      }

      if (config.swatches === 'dropdowns') {
        RefreshDropdowns(context, sectionId, Product, events, config, variantEvents);
        return;
      }

      // fallback for dropdowns or legacy
      options = Array.from(context.querySelectorAll('select.js-variant-selector'), (select) => select.value);

      variant = Product.variants.find((variant) => {
        return !variant.options.map((option, index) => {
          return options[index] === option;
        }).includes(false);
      });

      variantEvents(context, variant, config);
    });
  });

  (function sku() {
    var element = context.querySelector(".js-variant-sku");

    if ( !element ) return false;

    events.on("variantchange", function (variant, config) {
			if (!variant.sku) {
				element.parentNode.style.display = 'none';
			} else {
				element.innerHTML = variant.sku;
				element.parentNode.style.display = 'inline-block';
			}
    });
    events.on("variantunavailable", function (config) {
			element.innerHTML = config.unavailable;
    });

  })();

  (function price() {
    var elements = context.querySelectorAll("[data-price]");

    elements.forEach((element, i) => {
      var saleEl = element.querySelector("[data-sale-price]");
      var regEl = element.querySelector("[data-regular-price]");

      events.on("variantchange", function (variant) {
        var regPrice = money(variant.price);
        var salePrice = money(variant.price);

        // Check if on sale
        if ( variant.compare_at_price > variant.price ) {
          regPrice = money(variant.compare_at_price);
          salePrice = money(variant.price);

          element.classList.add('price--on-sale');
        } else {
          element.classList.remove('price--on-sale');
        }

        // Check if sold out
        if ( !variant.available ) {
          element.classList.add('price--sold-out');
        } else {
          element.classList.remove('price--sold-out');
        }

        // Set prices
        if ( saleEl ) saleEl.innerHTML = salePrice;
        if ( regEl ) regEl.innerHTML = regPrice;

        // Check if unavailable
        events.on("variantunavailable", function (variant) {
          if ( saleEl ) saleEl.innerHTML = config.unavailable;
          if ( regEl ) regEl.innerHTML = config.unavailable;
        });

      });
    });
  })();

  (function unit_price() {
    var elements = context.querySelectorAll("[data-unit-price-wrapper]");
    elements.forEach((element, i) => {
      events.on("variantchange", function (variant) {
        var unitPrice = "";
        var unitPriceSelector = element.querySelector('[data-unit-price]');

        if (variant.unit_price) {
          unitPrice = '(' + WAU.Helpers.formatMoney(variant.unit_price, config.money_format) +  ' / ' + getBaseUnit(variant) + ')';

          element.style.display = "inline-block";
        } else {
          element.style.display = "none";
        }

        unitPriceSelector.innerHTML = unitPrice;
      });
      events.on("variantunavailable", function(variant) {
        element.style.display = "none";
      });
    });
  })();

	(function add_to_cart() {
    var element = context.querySelector(".js-ajax-submit");

    if ( !element ) return false;

    events.on("variantchange", function (variant) {
      var text = config.button;
      var disabled = false;

      if ( !variant.available ) {
        text = config.sold_out;
        disabled = true;
      }

			element.setAttribute("data-variant-id", variant.id);
      element.innerHTML = text;
      element.disabled = disabled;
    });

    events.on("variantunavailable", function () {
      element.innerHTML = config.unavailable;
      element.disabled = true;
    });
  })();

  (function shop_pay() {
    const element = context.querySelector('#product-form-installment');

    if (!element) return false;

    const input = element.querySelector('input[name="id"]');

    events.on("variantchange", function (variant) {
      input.value = variant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  })();

  (function smart_payment_buttons() {
    var element = context.querySelector(".shopify-payment-button");

    if ( !element ) {
      return false;
    }

    events.on("variantchange", function (variant) {

      if ( !variant.available ) {
         element.style.display = 'none';
       } else {
         element.style.display = 'block';
       }

    });
  })();

  (function selling_plans() {
    var element = context.querySelector('[name="selling_plan"]');

    if ( !element ) return false;

    // Add selling plan input to submit form
    var submitForm = context.querySelector('.js-prod-form-submit');
    var input = document.createElement("input");
      input.name = "selling_plan";
      input.type = "hidden";
      input.className = "js-selling-plan";
      submitForm.appendChild(input);

    //Update selling plan input on select change
    element.addEventListener('change', function(event) {
      input.value = event.target.value;
    });
  })();

	function money(cents) {
		return WAU.Helpers.formatMoney(cents, config.money_format);
	}

	function getBaseUnit(variant) {
	 return variant.unit_price_measurement.reference_value != 1
     ? variant.unit_price_measurement.reference_value
     : variant.unit_price_measurement.reference_unit;
	}

  function variantEvents(context, variant, config) {
    if ( !variant ) {
      events.trigger("variantunavailable", config);
      Events.trigger("storeavailability:unavailable");
      return;
    }

    if ( Product.variants.length == 1 ) {
      if ( !variant.available ) {
        var element = context.querySelector(".product-price");
        element.innerHTML = config.sold_out;
      }
      return;
    }

    events.trigger("variantchange", variant, config);
    events.trigger("variantchange:option1:" + variant.option1);
    events.trigger("variantchange:option2:" + variant.option2);
    events.trigger("variantchange:option3:" + variant.option3);

    if ( context.querySelector('[data-store-availability-container]') ) {
      Events.trigger("storeavailability:variant", variant.id, Product.title);
    }

    if ( variant.featured_media ) {
      Events.trigger("variantchange:image", variant.featured_media.id, context);
    }

    if ( config.enable_history ) historyState(variant, context);

    updateVariantInput(variant, context);
  }

  function historyState(variant, context) {
    if ( !variant ) return;
    window.history.replaceState({ }, '', `${context.dataset.url}?variant=${variant.id}`);
  }

  function updateVariantInput(variant, context) {
    const input = context.querySelector('#formVariantId');
    if (!input) return false;
    input.setAttribute('name', 'id');
    input.value = variant.id;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  (function sale_icon() {
    const acceptedFormats = {
      "icon": "icon",
      "percentage": "percentage",
      "amount": "amount"
    };
    const selectors = {
      salePriceBadge: ".js-sale-item"
    };

    const saleIconEl = context.querySelector(selectors.salePriceBadge);
    const dataFormat = context.dataset.saleFormat;
    const savingsString = 'save {{ savings }}';

    if (typeof money !== 'function') {
      console.log('sale_icon:: Error. Money helper function is not available.');
      return false;
    }

    if (dataFormat == acceptedFormats.icon) {
      console.log('sale_icon:: Error. Format does not match an accepted format.');
      return false;
    }

    if (!config) {
      console.log('sale_icon:: Error. Do not have access to the config object for translations.');
      return false;
    }

    if (!saleIconEl) {
      console.log('sale_icon:: Error. No Sale icon element to work with.');
      return false;
    }

    function salePercentage(variant) {
      const difference = variant.compare_at_price - variant.price;
      const differencePercentage = Math.floor((difference / variant.compare_at_price) * 100);
      return differencePercentage + '%';
    };

    function saleAmount(variant) {
      const difference = variant.compare_at_price - variant.price;
      const formattedAmount = money(difference);
      return formattedAmount.replace(/\.00$/, '');
    }
    function showDiscount(variant, format, string, regex = /{{ savings }}/i) {

      if (!variant) {
        console.log('Error. No variant passed into function.');
        return false;
      }
      if (!format) {
        console.log('Error. No format was passed into function.');
        return false;
      }
      if (!string) {
        console.log('Error. No string passed into function.');
        return false;
      }

      switch (format) {
        case acceptedFormats.percentage:
          return string.replace(regex, salePercentage(variant));
          break;
        case acceptedFormats.amount:
          return string.replace(regex, saleAmount(variant));
          break;
      };
    };

    function updateSaleIcon(variant) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        saleIconEl.innerHTML = showDiscount(variant, dataFormat, savingsString);
        saleIconEl.style.display = 'inline-block'; // Ensure the badge is displayed
      } else {
        saleIconEl.style.display = 'none'; // Hide the badge if no discount is available
      }
    }

    events.on("variantchange", updateSaleIcon);
  })();


  (function variantInventoryQuantity() {
    const classes = {
      variantStockLevels: 'js-variant-stock-levels',
      variantStockLevelsMessage: 'js-variant-stock-levels__message',
      hide: 'visually-hidden',
      lowStock: 'low'
    };
    const selectors = {
      variantStockLevels: '.' + classes.variantStockLevels,
      variantStockLevelsMessage: '.' + classes.variantStockLevelsMessage,
      variantStockLevelsThreshold: 'data-variant-stock-level-threshold',
      stockIcon: '.js-stock-icon'
    };
    const DEFAULT_LIMIT = 11;
    const variantStockLevelEl = context.querySelector(selectors.variantStockLevels);
    const variantStockLevelMessageEl = context.querySelector(selectors.variantStockLevelsMessage);
    const stockIconEl = context.querySelector(selectors.stockIcon); // Stock icon element

    if (!variantStockLevelEl) {
      return false;
    }

    const stockLevelThreshold = variantStockLevelEl.getAttribute(selectors.variantStockLevelsThreshold) !== undefined
      ? parseInt(variantStockLevelEl.dataset.stockLevelThreshold, 10)
      : DEFAULT_LIMIT;

    const checkFadeSupport = () => typeof WAU.Helpers.fadeIn === 'function' && typeof WAU.Helpers.fadeOut === 'function';

    const showElement = (element) => {
      if (!element) return;
      element.classList.remove(classes.hide);
      if (checkFadeSupport()) {
        WAU.Helpers.fadeIn(element);
      }
    };

    const hideElement = (element) => {
      if (!element) return;
      if (checkFadeSupport()) {
        WAU.Helpers.fadeOut(element);
      } else {
        element.classList.add(classes.hide);
      }
    };

    const getMessage = (config, quantity, regex = /{{ count }}/) => {
      if (quantity <= stockLevelThreshold && quantity > 0) {
        return config.stock_levels.only_remaining.replace(regex, quantity);
      } else {
        return config.stock_levels.in_stock;
      }
    };

    events.on("variantchange", (variant) => {
      if (variant.inventory_management === 'shopify') {
        if (variant.inventory_quantity > 0) {
          // Check if the inventory is low
          if (variant.inventory_quantity <= stockLevelThreshold) {
            variantStockLevelMessageEl.innerHTML = getMessage(config, variant.inventory_quantity);
            stockIconEl.classList.add(classes.lowStock); // Add the "low" class
          } else {
            variantStockLevelMessageEl.innerHTML = config.stock_levels.in_stock;
            stockIconEl.classList.remove(classes.lowStock); // Remove the "low" class
          }
          showElement(variantStockLevelEl);
        } else {
          if (variant.inventory_policy === 'continue') {
            variantStockLevelMessageEl.innerHTML = config.stock_levels.in_stock;
            stockIconEl.classList.remove(classes.lowStock); // Ensure "low" class is removed for continue policy
            showElement(variantStockLevelEl);
          } else {
            // Sold out, hide stock level element and remove the "low" class
            hideElement(variantStockLevelEl);
            stockIconEl.classList.remove(classes.lowStock);
          }
        }
      } else {
        // Inventory is NOT tracked, always display "In stock, ready to ship"
        variantStockLevelMessageEl.innerHTML = config.stock_levels.in_stock;
        showElement(variantStockLevelEl);
        stockIconEl.classList.remove(classes.lowStock); // Ensure "low" class is removed for untracked inventory
      }
    });

    events.on("variantunavailable", (variant) => {
      hideElement(variantStockLevelEl);
      stockIconEl.classList.remove(classes.lowStock); // Remove the "low" class when unavailable
    });

  })();


}

ProductDetails = function (context, events, Product) {
  (function sku() {
    var element = context.querySelector(".js-variant-sku");

    if ( !element ) return false;

    events.on("variantchange", function (variant, config) {
			if (!variant.sku) {
				element.parentNode.style.display = 'none';
			} else {
				element.innerHTML = variant.sku;
				element.parentNode.style.display = 'grid';
			}
    });
    events.on("variantunavailable", function (config) {
			element.innerHTML = config.unavailable;
    });

  })();

  (function weight() {
    var element = context.querySelector(".js-variant-weight");

    if ( !element ) return false;

    events.on("variantchange", function (variant, config) {
      var variantWeight = variant.weight_in_unit;
      var variantWeightUnit = variant.weight_unit;
      if ( variantWeight > 0 ) {
        element.innerHTML = variantWeight + ' ' + variantWeightUnit;
      } else {
        element.innerHTML = config.unavailable;
      }
    });
    events.on("variantunavailable", function (config) {
      element.innerHTML = config.unavailable;
    });

  })();

}

ProductGallery = (function () {
  function init(context, sectionId) {
    let config = JSON.parse(context.querySelector('.js-product-gallery').dataset.galleryConfig || '{}'),
        main = context.querySelector('.js-carousel-main'),
        carouselNav = context.querySelector('.js-thumb-carousel-nav');

    if ( !main ) return false;

    this.mainSlider(main, carouselNav, config, context);
    if ( config.thumbPosition == 'bottom' && config.thumbSlider == true ) this.thumbSlider(carouselNav, main, context);

    if ( config.clickToEnlarge ) ProductGallery.enlargePhoto(context);

    // Fix iOS touchmove issue globally
    fixTouchMoveIssue();
  }

  function mainSlider(main, carouselNav, config, context) {
    let initialEl = main.querySelector("[data-image-id='" + context.dataset.initialVariant + "']"),
        initialIndex;

    if ( initialEl ) {
      initialIndex = initialEl.dataset.slideIndex;
    } else {
      initialIndex = 0;
    }

    var flkty = new Flickity( main, {
      // options
      fade: true,
      wrapAround: true,
      cellAlign: 'left',
      draggable: true,
      contain: true,
      pageDots: false,
      prevNextButtons: config.mainSlider,
      autoPlay: false,
      selectedAttraction: 0.01,
      dragThreshold: 5,
      adaptiveHeight: true,
      imagesLoaded: true,
      initialIndex: initialIndex,
      on: {
        ready: function() {
          let id = this.selectedElement.dataset.imageId;
        },
        change: function() {
          /* Set focus control on change */
          ProductGallery.removeFocus(context);
          ProductGallery.addFocus(this.selectedElement, context);

          /* Set media */
          ProductGallery.setActiveThumbnail(this.selectedElement.dataset.imageId, this.selectedElement, context);
          ProductGallery.switchMedia(this.selectedElement.dataset.imageId, context);

          /* Allow model drag */
          if ( this.selectedElement.classList.contains('model-slide') ) {
            if ( this.isDraggable ) {
              /* Turn off drag for model usage */
              this.options.draggable = !this.options.draggable;
              this.updateDraggable();
            }
          }
        }
      }
    });

    // Apply the resize override
    preventResizeWhileAnimating(flkty);

    ProductGallery.galleryEvents(flkty, context);

    if ( carouselNav ) ProductGallery.thumbnails(flkty, carouselNav, config, context);
  }

  function thumbSlider(wrapper, main, context) {
    var flktyThumbs = new Flickity( wrapper, {
      // options
      asNavFor: main,
      wrapAround: false,
      groupCells: true,
      cellAlign: 'left',
      draggable: true,
      contain: true,
      imagesLoaded: true,
      pageDots: false,
      autoPlay: false,
      selectedAttraction: 0.01,
      dragThreshold: 5,
      accessibility: false
    });
  }

  function thumbnails(flkty, carouselNav, config, context) {
    if ( !carouselNav ) return false;

    let thumbs = carouselNav.querySelectorAll('.js-thumb-item');

    if ( !thumbs ) return false;

    /* on thumbnail click and key enter */
    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', function(event){
        event.preventDefault();

        let index = this.dataset.slideIndex,
            el = carouselNav.querySelectorAll('.js-thumb-item')[index],
            mediaId = this.dataset.imageId;

        /* Update classes & aria */
        ProductGallery.setActiveThumbnail(mediaId, el, context);
        ProductGallery.switchMedia(mediaId, context);

        /* move thumb slider to position */
        ProductGallery.setThumbPos(this, carouselNav);

        /* change slide */
        flkty.select( index );

      });

      thumb.addEventListener('keypress', function(event){
        event.preventDefault();

        if(event.which == 13){ //Enter key pressed

          let index = this.dataset.slideIndex,
              el = carouselNav.querySelectorAll('.js-thumb-item')[index],
              mediaId = this.dataset.imageId;

          /* Update classes & aria */
          ProductGallery.setActiveThumbnail(mediaId, el, context);
          ProductGallery.switchMedia(mediaId, context);

          /* move thumb slider to position */
          ProductGallery.setThumbPos(this, carouselNav);

          /* change slide */
          flkty.select( index );

        }
      });
    });

  }

  function setThumbPos(selected, carouselNav) {

    carouselNav.scrollTo({
      top: selected.offsetTop - 20,
      left: 0,
      behavior: 'smooth'
    });
  }

  function galleryEvents(flkty, context) {

    /* On Variant Change and Initial Load */
    Events.on('variantchange:image', function(id, context){

      if ( id === null ) return false;

      /* Select new image in flickity */
      var main, el, index, curFlkty;

      main = context.querySelector('.js-carousel-main');

      if ( !main ) return false;

      el = main.querySelector("[data-image-id='" + id + "']");
      if ( !el ) return false;
      index = el.dataset.slideIndex;

      ProductGallery.setActiveThumbnail(id, el, context);
      ProductGallery.switchMedia(id, context);

      curFlkty = Flickity.data( main );
      curFlkty.select( index );

    });
  }

  function removeFocus(context) {
    let main;

    if ( context ) {
      main = context;
    } else {
      main = context.querySelector('.js-carousel-main');
    }

    /* Set all elements to no tab */
    context.querySelectorAll('.js-carousel-main *').forEach((item, i) => {
      item.setAttribute('tabIndex', '-1');
      item.blur();
    });

    let buttonContents = context.querySelectorAll('.flickity-button *');
    buttonContents.forEach((item, i) => {
      item.setAttribute('tabIndex', '-1');
      item.classList.add('js-hide-focus')
    });

    if (main.classList.contains('.flickity-enabled')) {
      main.setAttribute('tabIndex', '-1');
      main.classList.add('js-hide-focus');
    }

  }

  function addFocus(current, context) {
    /* Set current element to tab */
    if ( current.classList.contains('image-slide') ) {
      current.querySelector('img').setAttribute("tabIndex", "0");
    } else if ( current.classList.contains('video-slide') ) {
      current.querySelectorAll('.plyr__controls *').forEach((item, i) => {
        item.setAttribute("tabIndex", "0");
      });
    } else if ( current.classList.contains('external_video-slide') ) {
      current.querySelector('iframe').setAttribute("tabIndex", "0");
    } else if ( current.classList.contains('model-slide') ) {
      current.querySelectorAll('.shopify-model-viewer-ui__controls-area *').forEach((item, i) => {
        item.setAttribute("tabIndex", "0");
      });
    }
  }

  function enlargePhoto(context) {

    let buttons = context.querySelectorAll('.js-zoom-btn');

    if ( !buttons ) return false;

    buttons.forEach((button, i) => {
      button.addEventListener('click', function (event) {
      	event.preventDefault();

        var btn = event.target,
            index = btn.getAttribute('data-index'),
            index = parseInt(index,10);

        const loader = new WAU.Helpers.scriptLoader();
        loader.load([jsAssets.zoom]).then(() => {
          openPhotoSwipe(index);
        });

      });
    });

    var openPhotoSwipe = function(index) {
      var pswpElement = document.querySelectorAll('.pswp')[0];

      let images = context.querySelectorAll('#main-slider .image-slide');

      if ( images.length < 2 ) {
        var arrows = false;
      } else {
        var arrows = true;
      }

      let items = [];
      images.forEach((image, i) => {
        let imageTag = image.querySelector('.product__image');

        let item = {
          src: imageTag.getAttribute('data-zoom-src'),
          w: imageTag.getAttribute('width'),
          h: imageTag.getAttribute('height')
        }
        items.push(item);
      });

      var options = {
        index: index,
        arrowEl: arrows,
        captionEl: false,
        closeOnScroll: false,
        counterEl: false,
        history: false,
        fullscreenEl: false,
        preloaderEl: false,
        shareEl: false,
        tapToClose: false,
        zoomEl: true,
        getThumbBoundsFn: function(index) {
          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
          var thumbnail = context.querySelector('.product__image');
          var rect = thumbnail.getBoundingClientRect();
          return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
        }
      };

      var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
      gallery.init();

      gallery.listen('afterChange', function() {
        var flkty = Flickity.data('.js-carousel-main')
        var newIndex = gallery.getCurrentIndex();
        flkty.select (newIndex);
      });

    };
  }

  function switchMedia(mediaId, context) {
    let main = context.querySelector('.js-carousel-main'),
        currentMedia = main.querySelector('[data-product-single-media-wrapper]:not(.inactive)'),
        newMedia = main.querySelector('[data-product-single-media-wrapper]' + "[data-thumbnail-id='product-template-" + mediaId +"']"),
        otherMedia = main.querySelectorAll('[data-product-single-media-wrapper]' + ":not([data-thumbnail-id='product-template-" + mediaId + "'])");

    currentMedia.dispatchEvent(
      new CustomEvent('mediaHidden', {
        bubbles: true,
        cancelable: true
      })
    );

    newMedia.classList.add('active-slide');
    newMedia.classList.remove('inactive');
    newMedia.dispatchEvent(
      new CustomEvent('mediaVisible', {
        bubbles: true,
        cancelable: true
      })
    );

    otherMedia.forEach(
      function(el) {
        el.classList.add('inactive');
        el.classList.remove('active-slide');
      }.bind(this)
    );
  }

  function setActiveThumbnail(mediaId, el, context) {

    let main = context.querySelector('.js-carousel-main'),
        carouselNav = context.querySelector('.js-thumb-carousel-nav');

    if (typeof mediaId === 'undefined') {
       mediaId = main.querySelector('[data-product-single-media-wrapper]:not(.hide)').dataset.mediaId;
     }

     if ( carouselNav ) {
       /* remove selected class from all */
       carouselNav.querySelectorAll('.js-thumb-item').forEach((item, i) => {
         item.classList.remove('is-nav-selected');
         item.classList.remove('active-slide');
         item.removeAttribute('aria-current');
       });
     }

     /* add selected class */
     let thumbActive = context.querySelector(".js-thumb-item[data-image-id='" + mediaId + "']");
     if ( thumbActive ) {
       thumbActive.classList.add('is-nav-selected');
       thumbActive.classList.add('active-slide');
       thumbActive.setAttribute('aria-current', true);
     }
   }

   function fixTouchMoveIssue() {
    let touchingCarousel = false;
    let startXCoordinate;

    document.body.addEventListener('touchstart', function(e) {
      if (e.target.closest('.flickity-slider')) {
        touchingCarousel = true;
      } else {
        touchingCarousel = false;
        return;
      }
      startXCoordinate = e.touches[0].pageX;
    });

    document.body.addEventListener('touchmove', function(e) {
      if (!touchingCarousel || !e.cancelable || Math.abs(e.touches[0].pageX - startXCoordinate) < 8) return;
      e.preventDefault();
      e.stopPropagation();
    }, { passive: false });
  }

  // Prevent resize in Flickity if still animating
  function preventResizeWhileAnimating(flktyInstance) {
    var originalResize = flktyInstance.resize;
    flktyInstance.resize = function() {
      if (!this.isAnimating) {
        originalResize.call(this);
      }
    };
  }

  return {
    init: init,
    mainSlider: mainSlider,
    thumbSlider: thumbSlider,
    thumbnails: thumbnails,
    setThumbPos: setThumbPos,
    galleryEvents: galleryEvents,
    removeFocus: removeFocus,
    addFocus: addFocus,
    enlargePhoto: enlargePhoto,
    switchMedia: switchMedia,
    setActiveThumbnail: setActiveThumbnail
  };

})();

ProductButtons = function(context, events) {
  (function quantity() {
    var element = context.querySelector(".product-qty, .formQty");

    events.on("quantitycontrol:click", change);

    function change(value) {
      var quantity = parseInt(element.value) + value;

      if ( quantity < 1 ) return false;

      element.value = quantity;
    }
  })();

  (function quantity_controls() {
    Control(".js-qty-up", 1);
    Control(".js-qty-down", -1);

    function Control(selector, value) {
      var element = context.querySelector(selector);

      if ( !element ) return false;

      element.addEventListener("click", function (event) {
        event.preventDefault();
        events.trigger("quantitycontrol:click", value);
      });
      element.addEventListener("keydown", function(event) {
        if (event.keyCode === 13) {
          event.preventDefault();
          events.trigger("quantitycontrol:click", value);
        }
      });
    }
  })();
}



ProductDrawer = function(events) {

  //
  // Variables
  //

  const container = document.querySelector('.js-product-drawer');
  const form = container.querySelector('.js-prod-form-submit');
  const variantIdInput = form.querySelector('#formVariantId');
  const productQuantityInput = container.querySelectorAll('.product__quantity-input')
  const addToCartButtons = container.querySelectorAll('.js-ajax-submit');


  // Initialize the product "drawer"
  var drawer = new CupertinoPane('.js-product-drawer', {
      breaks: {
        top: { enabled: false },
        middle: { enabled: false },
        bottom: { enabled: true, height: 203 },
      },
      initialBreak: 'bottom',
  		backdrop: false,
      fastSwipeClose: true,
      onTransitionEnd: (e) => {
        document.body.style.overflowY = "auto";
      },
      onDidPresent: (e) => {
        let paneEl = document.querySelector('.cupertino-pane-wrapper .pane');
        paneEl.addEventListener('touchstart', () => {

          document.body.style.overflowY = "hidden";
        });
     }
  });


  //
  // Functions
  //


  /**
   * @description Displays the "product drawer" after scroll so many pixels.
   */
  function scrollInit() {

    var y = window.scrollY;
    if (y >= 800) {
      drawer.present({animate: true});
      window.removeEventListener("scroll", scrollInit);
    }
  };


  /**
   * @description Helper method for updating the selected swatches inside the "drawer"
   * @param  {Object} variant Selected product variant
   */
  function updateSwatches(variant) {

    // Get all swatches element
    let allSwatches = container.querySelectorAll('.swatches__option-value');

    // Bail if we do not have any swatches.
    if (!allSwatches.length > 0) {
      console.warn('Error. There are no swatch elements to updarte.');
      return false;
    }

    // Loop through each swatch element and update value to match selected swatch.
    allSwatches.forEach((swatch) => {
      switch(swatch.id) {
        case 'selected-option-1':
          swatch.innerHTML = variant.option1;
          break;
        case 'selected-option-2':
          swatch.innerHTML = variant.option2;
          break;
        case 'selected-option-3':
          swatch.innerHTML = variant.option3;
          break;
        default:
          swatch.innerHTML = 'Error';
      }
    });
  };


  /**
   * @description Helper function to update the "add to cart" buttons
   * @param  {Nodes} buttons  DOM elements.
   * @param  {Object} variant Selected product variant.
   * @param  {Object} config  Config object that holds translations.
   */
  function updateAddToCartButtons(buttons, variant, config) {

    // Check that we have "add to cart" buttons to work with.
    if (buttons.length > 0) {

      // Loop through each "add to cart" buttons.
      buttons.forEach((button) => {

        // Check if we have variant ID attribute.
        if (button.hasAttribute('data-variant-id')) {

          // Set attribute.
          button.setAttribute('data-variant-id', variant.id)
        }

        // If product variant is not available
        if (!variant.available) {
          button.value = config.sold_out;
          button.innerHTML = config.sold_out;
          button.disabled = true;
        } else {
          button.value = config.button;
          button.innerHTML = config.button;
          button.disabled = false;
        }
      });
    }
  };


  /**
   * @description Update hidden variant ID input.
   * @param  {[type]} input   [description]
   * @param  {[type]} variant [description]
   */
  function updateVariantIdInput(input, variant) {

    // Bail if there is no input
    if (!input) {
      console.warn('Error. No hidden variant ID element to update.');
      return false;
    } else {

      // Update the input value to the variant ID.
      input.value = variant.id;
    }
  };


  /**
   * @description Update price elements when variant changes.
   * @param  {Object} variant  [description]
   * @param  {Object} config   [description]
   */
  function updatePrice(variant, config) {

    // Get the elements
    var elements = container.querySelectorAll("[data-price]");

    elements.forEach((element) => {
      var saleEl = element.querySelector("[data-sale-price]");
      var regEl = element.querySelector("[data-regular-price]");

      var regPrice = money(variant.price, config);
      var salePrice = money(variant.price, config);

      // Check if on sale
      if ( variant.compare_at_price > variant.price ) {
        regPrice = money(variant.compare_at_price, config);
        salePrice = money(variant.price, config);

        element.classList.add('price--on-sale');
      } else {
        element.classList.remove('price--on-sale');
      }

      // Check if sold out
      if ( !variant.available ) {
        element.classList.add('price--sold-out');
      } else {
        element.classList.remove('price--sold-out');
      }

      // Set prices
      if ( saleEl ) saleEl.innerHTML = salePrice;
      if ( regEl ) regEl.innerHTML = regPrice;
    });
  };


  /**
   * @description Update the price when the variant is unavailable.
   * @param  {Object} config Config object contains text translations.
   */
  function updateUnavailablePrice(config) {

    var elements = container.querySelectorAll("[data-price]");

    elements.forEach((element) => {
      var saleEl = element.querySelector("[data-sale-price]");
      var regEl = element.querySelector("[data-regular-price]");
    });
  };


  /**
   * @description Handle unavailable "add to cart" button.
   * @param  {Object} config Config object contains text translations.
   */
  function updateUnavailableAddToCart(config) {

    var element = container.querySelector(".js-ajax-submit");
    element.innerHTML = config.unavailable;
    element.disabled = true;
  };


  /**
   * @description Helper function to format money.
   */
  function money(cents, config) {
    return WAU.Helpers.formatMoney(cents, config.money_format);
  };


  /**
   * @description Handle variant chang eevents.
   */
  function handleVariantChangeEvent(variant, config) {

    updateSwatches(variant);

    updateAddToCartButtons(addToCartButtons, variant, config);

    updateVariantIdInput(variantIdInput, variant);

    updatePrice(variant, config);
  };

  /**
   * @description Hanle variant unavailable event
   */
  function handleVariantUnavailableEvent(config) {

    updateUnavailablePrice(config);

    updateUnavailableAddToCart(config);
  };

  //
  // Events
  //

  events.on('variantchange', handleVariantChangeEvent);

  events.on('variantunavailable', handleVariantUnavailableEvent);

  if ( window.matchMedia("(max-width: 967px)").matches ) {
    window.addEventListener("scroll", scrollInit);
  }
}

GiftCardRecipient = function (context, sectionId, events, Product) {
  const container = context.querySelector(".recipient-form");
  if (!container) return false;
  const recipientCheckbox = container.querySelector(`#Recipient-Checkbox-${ sectionId }`);
  recipientCheckbox.disabled = false;
  const emailInput = container.querySelector(`#Recipient-email-${ sectionId }`);
  const nameInput = container.querySelector(`#Recipient-name-${ sectionId }`);
  const messageInput = container.querySelector(`#Recipient-message-${ sectionId }`);
  const hiddenField = container.querySelector(`#Recipient-Control-${ sectionId }`);
  hiddenField.disabled = true;
  const form = container.closest('.js-prod-form-submit');
  const formSubmitButton = form.querySelector('.js-ajax-submit');
  const defaultErrorMessage = context.querySelector('.js-error-msg').innerHTML;

  form.addEventListener('change', handleChange);

  function handleChange(event) {
    if (!recipientCheckbox.checked) {
      clearForm();
    } else {
      emailInput.required = true;
    }
  }

  function clearForm() {
    clearErrorMessage();
    emailInput.value = '';
    nameInput.value = '';
    messageInput.value = '';
    emailInput.required = false;
  }

  function clearErrorMessage() {
    container.querySelectorAll('.recipient-fields .form__message').forEach(field => {
      field.classList.add('hidden');
      const textField = field.querySelector('.error-message');
      if (textField) textField.innerText = '';
    });
  }

  function displayErrorMessage(title, body, formContext) {
    if (!form.isSameNode(formContext)) return;
    clearErrorMessage();
    if (typeof body === 'object') {
      return Object.entries(body).forEach(([key, value]) => {
        const errorMessageId = `RecipientForm-${ key }-error-${ sectionId }`
        const fieldSelector = `#Recipient-${ key }-${ sectionId }`;
        const placeholderElement = container.querySelector(`${fieldSelector}`);
        const label = placeholderElement?.getAttribute('placeholder') || key;
        const message = `${label} ${value}`;
        const errorMessageElement = container.querySelector(`#${errorMessageId}`);
        const errorTextElement = errorMessageElement?.querySelector('.error-message')
        if (!errorTextElement) return;

        errorTextElement.innerText = `${message}.`;
        errorMessageElement.classList.remove('hidden');
      });
    }
  }

  function updateErrorMessage(title, config, formContext) {
    if (!form.isSameNode(formContext)) return;
    const errorMessage = context.querySelector('.js-error-msg');
    if (!errorMessage) {
      console.warn('No error message found.');
      return;
    }
    errorMessage.innerHTML = `<strong>${config.form_error}</strong> ${title}`;

    // Set back to default
    setTimeout(() => {
      errorMessage.innerHTML = defaultErrorMessage;
    }, 4000)
  }

  Events.on('recipientform:errors', function(title, body, config, addToCartForm) {
    displayErrorMessage(title, body, addToCartForm);
    updateErrorMessage(title, config, addToCartForm);
  });
};


function initOftenBoughtWith(container) {
  container.querySelectorAll('[data-often-bought-with]').forEach((root) => {
    const track = root.querySelector('[data-often-bought-with-track]');
    const prev = root.querySelector('[data-often-bought-with-prev]');
    const next = root.querySelector('[data-often-bought-with-next]');
    if (!track) return;

    const getScrollStep = () => {
      const item = track.querySelector('.often-bought-with__item');
      if (!item) return track.clientWidth;
      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return item.offsetWidth + gap;
    };

    const updateNav = () => {
      if (!prev || !next) return;
      const maxScroll = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= maxScroll - 1;
    };

    if (prev && next) {
      prev.addEventListener('click', () => {
        track.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
      });
      next.addEventListener('click', () => {
        track.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav);
      updateNav();
    }
  });
}

// Alternative that just makes the product form work.
function ProductQuickForm(container) {

  if (!container) {
    console.error('Error. Missing container element.');
    return;
  }

  var events = new EventEmitter3();
  events.trigger = events.emit; // alias

  var productJson = container.querySelector('.product-json');

  if ( !productJson ) return false;

  var Product = productJson.innerHTML,
      Product = JSON.parse(Product || '{}');

  var sectionId = container.getAttribute('data-product-id');

  ProductForm(container, sectionId, events, Product);
}


function Product(container) {
  var events = new EventEmitter3();
  events.trigger = events.emit; // alias

  var productJson = container.querySelector('.product-json');

  if ( !productJson ) return false;

  var Product = productJson.innerHTML,
      Product = JSON.parse(Product || '{}');

  var sectionId = container.dataset.sectionId;

  // Record if on a product page
  if (document.body.classList.contains('template-product')) {
    Shopify.RecordViewedProducts.recordRecentlyViewed();
  }

  if ( container.querySelector('[data-product-form]') ) {
    ProductForm(container, sectionId, events, Product);
  }

  // Combined listings: the parent product's variant ID is virtual (non-purchasable) so pickup
  // availability returns nothing on load. Fetch the initial child product section to get the
  // real variant ID and fire the same event that variant clicks fire.
  if ( container.querySelector('[data-store-availability-container]') ) {
    const swatches = container.querySelector('.product__variants-swatches');
    const dropdowns = container.querySelector('.product__variants-select');
    const wrapper = swatches || dropdowns;
    if (wrapper) {
      const currentUrl = wrapper.dataset.url || window.location.pathname;
      let childUrl, ids;
      if (swatches) {
        const checked = wrapper.querySelector('input[type="radio"]:checked[data-product-url]');
        childUrl = checked?.dataset.productUrl;
        ids = [...wrapper.querySelectorAll('input[type="radio"]:checked')].map(el => el.dataset.optionValueId).filter(Boolean);
      } else {
        for (const sel of wrapper.querySelectorAll('select.js-variant-selector')) {
          const opt = sel.selectedOptions[0];
          if (opt?.dataset.productUrl && opt.dataset.productUrl !== currentUrl) { childUrl = opt.dataset.productUrl; break; }
        }
        ids = [...wrapper.querySelectorAll('select.js-variant-selector')].map(s => s.selectedOptions[0]?.dataset.optionValueId).filter(Boolean);
      }
      if (childUrl && childUrl !== currentUrl) {
        const key = `${childUrl}-${ids.join(',')}-${sectionId}`;
        const firePickup = html => {
          try {
            const v = JSON.parse(new DOMParser().parseFromString(html, 'text/html').querySelector('[data-selected-variant]')?.innerHTML || 'null');
            if (v?.id) Events.trigger('storeavailability:variant', v.id, Product.title);
          } catch(e) {}
        };
        cachedVariantHtml.has(key)
          ? firePickup(cachedVariantHtml.get(key))
          : fetch(`${window.location.origin}${childUrl}?section_id=${sectionId}&option_values=${ids.join(',')}`)
              .then(r => r.text()).then(t => { cachedVariantHtml.set(key, t); firePickup(t); });
      }
    }
  }

  if ( container.querySelector('[data-product-countdown]') ) {
    ProductCountdown(container);
  }

  if ( container.querySelector('.js-notify-form-trigger') ) {
    container.querySelector('.js-notify-form-trigger').addEventListener('click', function() {
      event.preventDefault();
      WAU.Helpers.fadeToggle(container.querySelector('.js-notify-form-wrap'), 'grid');
    });
  }

  if ( container.querySelector('[data-product-gallery]') ) {
    ProductGallery.init(container, sectionId);
  }

  initOftenBoughtWith(container);

  if ( container.querySelector('[data-product-buttons]') ) {
    ProductButtons(container, events);
  }

  if ( document.querySelector('[data-product-details]') ) {
    ProductDetails(document.querySelector("[data-product-details]"), events, Product);
  }

  if ( document.querySelector('[data-product-drawer]') ) {
    ProductDrawer(events);
  }

  if ( container.querySelector('[data-recipient-form]') ) {
    GiftCardRecipient(container, sectionId, events, Product);
  }

  /* Product media */
  if ( container.querySelectorAll('[data-product-media-type-video]').length > 0 ) {
    setTimeout(function() {
      container.querySelectorAll('[data-product-media-type-video]').forEach(function (item, sectionId) {
        ProductVideo.init(item, sectionId);
      });
    }, 90);
  }

  let modelViewerElements = container.querySelectorAll('[data-product-media-type-model]');

  if ( modelViewerElements.length > 0 ) {
    setTimeout(function() {
      ProductModel.init(modelViewerElements, sectionId);
    }, 90);
  }

  var self = this;

  document.addEventListener('shopify_xr_launch', function() {
    var currentMedia = document.querySelector('[data-product-single-media-wrapper]:not(.inactive)', self);

    currentMedia.dispatchEvent(
      new CustomEvent('xrLaunch', {
        bubbles: true,
        cancelable: true
      })
    );
  });

}

document.querySelectorAll('[data-section-type="product"]').forEach(function(container, i){
  Product(container);
});

document.addEventListener("shopify:section:load", function(event) {
  if (event.target.querySelector('[data-section-type="product"]')) Product(event.target.querySelector('[data-section-type="product"]'));
});
